import { Component, OnInit, ViewEncapsulation, OnDestroy, inject, viewChild } from '@angular/core';
import { ApplicantDetailsFieldsComponent } from '../../components/applicant-details/applicant-details-fields/applicant-details-fields';
import { MCButtonComponent } from '@maslul/common-components';
import { ApplicantDetailsStore } from '../../../../../services/store/applicant-details';
import { ApplicantDetailsService } from '../../../../../services/pages/applicant-details/applicant-details';
import { ProductsService } from '../../../../../services/pages/products/products';
import { ApplicantDetails } from '../../../../../models/applicant/applicant-details';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { RequestApprovalTypeDetailsStore } from '../../../../../services/store/approval-type-details-store';
import { PageBaseComponent } from '../../../../shared/page-base';
import { FocusOnTabDirective } from '../../../../../services/shared/directives/focus-on-tab';
import { TABS } from '../../../../../enum/request/TABS';
import { MCConfigService } from '@maslul/common-services';
import { GeneralStore } from '../../../../../services/store/general';

@Component({
    selector: 'mi-applicant-details',
    imports: [
        ApplicantDetailsFieldsComponent,
        MCButtonComponent,
        FocusOnTabDirective],
    templateUrl: './applicant-details.html',
    styleUrl: './applicant-details.scss',
    encapsulation: ViewEncapsulation.None
})
export class ApplicantDetailsComponent extends PageBaseComponent implements OnInit, OnDestroy {

    private applicantDetailsStore = inject(ApplicantDetailsStore);
    private applicantDetailsService = inject(ApplicantDetailsService);
    private productService = inject(ProductsService);
    private translateService = inject(TranslateService);
    private configService = inject(MCConfigService);
    private requestApprovalTypeDetailsStore = inject(RequestApprovalTypeDetailsStore);

    applicant: ApplicantDetails | undefined;
    readonly applicantFieldComponent = viewChild.required(ApplicantDetailsFieldsComponent);
    private subscription: Subscription = new Subscription();
    genericText: any;
    validationText: any;
    tabsText: any;
    isExistGeneralDetailsTab: boolean = false;

    ngOnInit(): void {
        this.initText();
        this.init();
    }

    init() {
        this.applicant = this.applicantDetailsStore.getSnapshot().applicant;

        this.isExistGeneralDetailsTab = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTabs.includes(TABS.GENERAL_DETAILS);
    }

    initText() {
        this.subscription.add(this.translateService.stream('validationMessages').subscribe(translation => {
            this.validationText = translation;
        }));
        this.subscription.add(this.translateService.stream('generic').subscribe(translation => {
            this.genericText = translation;
        }));
        this.subscription.add(this.translateService.stream('tabs').subscribe(translation => {
            this.tabsText = translation;

        }));
    }


    back() {
        this.applicantDetailsService.saveToStore(this.applicantFieldComponent().applicantDetailsForm);
        this.navigate('approval-type-method');
    }

    next() {

        this.applicantFieldComponent().applicantDetailsForm.markAllAsTouched();
        const isValid = this.applicantFieldComponent().applicantDetailsForm.valid;
        this.applicantDetailsService.saveToStore(this.applicantFieldComponent().applicantDetailsForm);

        if (isValid || this.configService.getConfiguration().noValidCheck == "true") {
            this.applicantDetailsService.updateFormState();

            if (this.isExistGeneralDetailsTab) {
                this.navigate('general-details');
            }
            else {
                this.productService.nextToProductTab();

            }

        }
    }



    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

}
